import { useFragment } from "react-relay";
import type { orderPriceDisplay_OrderFragment$key } from "@relay/orderPriceDisplay_OrderFragment.graphql";
import { OrderIdDisplayTypes } from "./order-id-display.types";
import { InvoiceProviderLink } from "../invoice-provider-link";
import { ORDER_FRAGMENT } from "../order-price-display/order-price-display.graphql";

export const OrderIdDisplay = ({ orderFragmentRef }: OrderIdDisplayTypes) => {
	const order = useFragment<orderPriceDisplay_OrderFragment$key>(
		ORDER_FRAGMENT,
		orderFragmentRef,
	);
	if (order.invoiceData)
		return <InvoiceProviderLink invoiceDataFragmentRef={order.invoiceData} />;
	return <div></div>;
};
